import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-053cc4e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-5 mb-10" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-content-center"
}
const _hoisted_4 = {
  key: 1,
  class: "form-container"
}
const _hoisted_5 = { class: "mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]" }
const _hoisted_6 = { class: "justify-center" }
const _hoisted_7 = { class: "flex mt-[1.5rem]" }

import { ref } from 'vue';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { ICompanyMatriculeImportForm } from "@/models/companyMatricule/ICompanyMatriculeImportForm";
import { getPaginatedCompanyForDropDown } from '@/_services/company/company';
import ProgressSpinner from "primevue/progressspinner";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportCompanyMatricule',
  setup(__props) {

const form = ref<ICompanyMatriculeImportForm>({
    file: null,
    companyUuid: '',
    importType: 'enable'
});
const isLoading = ref<boolean>(false);

async function searchCompanyOptions({ search, page, hasNextPage }) {
    const [totalCompaniesRecordsForDropDown, companiesForDropDown] = await getPaginatedCompanyForDropDown(5, page, search, true);

    const hasItems = companiesForDropDown.length > 0;
    if (hasItems && page !== totalCompaniesRecordsForDropDown) {
        hasNextPage();
    }

    return companiesForDropDown;
}

const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}

const onSubmit = async (formValue, formNode) => {
    try {
        const importType = formValue.importType;
        const action = importType === 'enable' ? 'activer' : 'désactiver';
        const file = formValue.file?.[0]?.file;

        if (!file) {
            await swal.error('Aucun fichier sélectionné.');
            return;
        }

        const filename = file.name;
        if (!filename.endsWith(".csv")) {
            await swal.error('Le fichier doit être au format CSV.');
            return;
        }
        
        const responseLevel1 = await swal.confirm(
            `Êtes-vous sûr de vouloir ${action} ces matricules ?`,
            "Annuler",
            "Importer"
        );

        if (!responseLevel1.isConfirmed) {
            return;
        }

        const payload = new FormData();
        payload.append('file', file, filename);
        payload.append('companyUuid', formValue.companyUuid);
        payload.append('importType', importType);

        showSpinner();
        try {
            const { data } = await ApiService.post("admin/company-matricule/import-csv", payload);

            await swal.success(
                'Succès',
                "Les matricules sont en attente d'import, vous serez notifié par mail de leur traitement."
            );

            window.location.reload();
        } catch (error: any) {
            let errorMsg = "Une erreur est survenue";
            if (error.response?.data?.errors) {
                error.response.data.errors.forEach((err) => {
                    console.error('Error:', err.message);
                });

                if (error.response.data.errors[0]?.message) {
                    errorMsg = error.response.data.errors[0].message;
                }
            } else if (!error.response) {
                errorMsg = "Erreur de connexion au serveur";
            }

            await swal.error(errorMsg);
            window.location.reload();
        } finally {
            hideSpinner();
        }

    } catch (error) {
        console.error('Unexpected error in onSubmit:', error);
        hideSpinner();
        await swal.error('Une erreur inattendue est survenue.');
    }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("catalogue.registrationNumber.title")), 1)
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(ProgressSpinner), { "aria-label": "Chargement" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FormKit, {
                type: "form",
                id: "company-matricule-import-form",
                actions: false,
                model: form.value,
                onSubmit: onSubmit,
                "outer-class": "w-full",
                "incomplete-message": "Veuillez remplir tous les champs correctement"
              }, {
                default: _withCtx(({ state: { valid } }) => [
                  _createVNode(_component_FormKit, {
                    type: "select",
                    name: "importType",
                    modelValue: form.value.importType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.importType) = $event)),
                    label: "Action*",
                    validation: "required",
                    "validation-messages": {required: 'Veuillez selectionner Activer ou Désactiver.'},
                    options: [
                            { label: 'Activer', value: 'enable' },
                            { label: 'Désactiver', value: 'disable' }
                        ]
                  }, null, 8, ["modelValue", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: "autocomplete",
                    name: "companyUuid",
                    modelValue: form.value.companyUuid,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.companyUuid) = $event)),
                    label: "Entreprise*",
                    placeholder: "Sélectionner une société",
                    validation: "required",
                    "empty-message": "Aucune propriété trouvée",
                    options: searchCompanyOptions,
                    "validation-messages": {required: 'Veuillez sélectionner une société.'}
                  }, null, 8, ["modelValue", "validation-messages"]),
                  _createVNode(_component_FormKit, {
                    type: "file",
                    name: "file",
                    label: "Fichier CSV*",
                    help: "Sélectionnez le fichier à uploader.",
                    accept: ".csv",
                    placeholder: "Sélectionnez un fichier.",
                    validation: "required|validateFileExtension:csv",
                    "validation-messages": {
                            required: 'Aucun fichier sélectionné.',
                            validateFileExtension: 'Le fichier doit être au format CSV.'
                        }
                  }, null, 8, ["validation-messages"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_FormKit, {
                      type: "submit",
                      label: "Importer",
                      disabled: !valid,
                      class: "btn"
                    }, null, 8, ["disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ])
        ]))
  ], 64))
}
}

})